import React from 'react';
import { useEffect, useState } from 'react';
import axios from 'axios';
import ReactPlayer from 'react-player';
import './Gallery.css';

const API_KEY = 'AIzaSyCv4WyqIsDhWVzYVbDSafTb0obxWWaJe8E'; // 🔐 Replace with your actual key
const CHANNEL_ID = 'UCX71hO_FUsuqLOkelSxXcDg'; // 📺 Replace with your channel ID
const MAX_RESULTS = 6;

function Gallery() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchVideos = async () => {
      const url = `https://www.googleapis.com/youtube/v3/search?key=${API_KEY}&channelId=${CHANNEL_ID}&part=snippet,id&order=date&maxResults=${MAX_RESULTS}`;
      try {
        const res = await axios.get(url);
        const videoItems = res.data.items.filter(item => item.id.kind === "youtube#video");
        setVideos(videoItems);
      } catch (err) {
        console.error("Failed to fetch videos", err);
      }
    };

    fetchVideos();
  }, []);

  return (
    <div>
      <h2 className='text-center'>Media</h2>
      <div className="video-grid">
        {videos.map(video => (
          <div key={video.id.videoId} className="video-card">
            <ReactPlayer 
              url={`https://www.youtube.com/watch?v=${video.id.videoId}`}
              controls
              width="100%"
            />
            <p>{video.snippet.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Gallery;
